/* eslint-disable */
import Vue from "vue";
import App from "./App.vue";

// Internationalization
import VueI18n from "vue-i18n";

import Notifications from "vue-notification";
import vueSmoothScroll from "vue-smooth-scroll";
import Vuelidate from "vuelidate";
import "vuetify/dist/vuetify.min.css"; // Ensure you are using css-loader
import "@/styles/index.scss"; // global css
import "./plugins/vuetify";

import axios from "axios";
import VueAxios from "vue-axios";
import messages from "./locale";
import store from "./stores";
import router from "./router";

Vue.use(VueAxios, axios);
Vue.use(VueI18n);
Vue.use(vueSmoothScroll);
Vue.use(Vuelidate);
Vue.use(Notifications);
// Vue.use(window.vuelidate.default);

const i18n = new VueI18n({
  locale: store.getters.langKey,
  fallbackLocale: "id",
  messages,
});

Vue.config.productionTip = false;

new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
